// @file Confirmation-dialog button schemes, in a module of their own so a store can describe a
// dialog without importing the component (and its button subtree) into that store's chunk.

export enum OzConfirmationDialogBoxButtonScheme {
  // `confirmButton` is highlighted as the primary action
  Default = 'Default',
  // `confirmButton` is highlighted in red to signal danger
  Danger = 'Danger',
  // `cancelButton` is positioned as the primary action. `confirmButton`'s color is muted
  PromoteCancellation = 'PromoteCancellation',
  // Features a secondary action button, along with save and cancel
  PrimarySecondaryDestructiveCancel = 'PrimarySecondaryDestructiveCancel',
  // Features a secondary action and a cancel button
  SecondaryDestructiveCancel = 'SecondaryDestructiveCancel',
  // Features a primary destructive button, a secondary destructive action, and a cancel button
  PrimaryDestructiveSecondaryDestructiveCancel = 'PrimaryDestructiveSecondaryDestructiveCancel',
  // Features a confirm button only
  ConfirmOnly = 'ConfirmOnly',
  // Features a confirm button and a secondary action button
  PrimaryAndSecondary = 'PrimaryAndSecondary',
}
